export interface AxiosResponse {
    data: any;
    status: number | string;
    message: string;
}

export interface SaleAngle {
    name: string,
    description: string
}

export interface FunnelPayload {
    products: any[],
    brand_name: string,
    sale_angles: SaleAngle[],
    free_shipping: boolean,
    warranties: number,
    template_design: {
        theme: string,
        primary_color: string,
        secondary_color: string,
        template_name?: string,
        cover_style?: string,
        style_sheet?: string,
        palette?: string,
    },
    data_for_context: any,
    is_custom_sections_only?: boolean
}

// Multi-funnel payload (Flow B) — PUT /websites/bulk
export interface TemplatePage {
    id: string;
    name: string;
    type: string;
    sort: number;
    page: string;
    source?: string;
    metadata?: Record<string, any>;
}

export interface MultiFunnelItem {
    brand_name: string;
    sale_angles: SaleAngle[];
    free_shipping: boolean;
    warranties: number;
    template_structure?: {
        template_pages: TemplatePage[];
    };
    template_design?: {
        theme: string;
        primary_color: string;
        secondary_color: string;
        template_name?: string;
        cover_style?: string;
        style_sheet?: string;
        palette?: string;
    };
    is_custom_sections_only?: boolean;
}

export interface MultiFunnelProduct {
    external_id: string | null;
    provider_id: string | null;
    name: string;
    description: string;
    price: number;
    url_images: string[];
    images?: string[];
    type: 'PRINCIPAL' | 'UP_SELL' | 'BUMP_OFFER';
    variants?: any;
}

export interface MultiFunnelPayload {
    products: MultiFunnelProduct[];
    funnels: MultiFunnelItem[];
    data_for_context: {
        pain_detection: string;
        buyer_detection: string;
        recommended_sales_angles: SaleAngle[];
    };
}

export interface AnalyticsFunnelPayload {
    owner_id: string;
    website_id: string;
    created_at: string;
}

export enum VideoStatus {
    INITIALIZING = "INITIALIZING",
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "FINISHED",
    FAILED = "ERROR",
}